import { Checkbox, Descriptions, Spin, Typography } from "antd";
import { fetchCertificateData } from "lib/certificateData";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useGetProjectQuery } from "store/is/projectapi";

export default function SourcingDeclaration({yieldsRequiringSourcing, onDeclarationChange}) {
  const userOrgName = useSelector((state) => state.auth?.org?.name);
  const yieldPeriod = yieldsRequiringSourcing[0].yield_period;
  const [descriptionData, setDescriptionData] = useState()
  const [spinning, setSpinning] = useState(false);
  const { project_id: projectId } = yieldsRequiringSourcing[0];
  const { data: projectData } = useGetProjectQuery(projectId);
  const projectOrgId = projectData?.data[0]?.organization;

  useEffect(() => {
    const formatBundleIDs = (yieldDetails) => {
      return [ 
        ...new Set(yieldDetails.map(yieldDetail => `${yieldDetail.finaltoken_name}-${yieldDetail.finaltoken_id}`))
      ].join(', ')
    }

    (async () => {
      try {
        setSpinning(true);
        const { intervention_name: projectName, project_id_readable: projectIdReadable } = yieldsRequiringSourcing[0]
        const assetIds = yieldsRequiringSourcing.map(yieldDetail => yieldDetail.asset_id);
        const yieldIds = yieldsRequiringSourcing.map(yieldDetail => yieldDetail.yield_id);
        const creditBundles = formatBundleIDs(yieldsRequiringSourcing);
        const cropData = await fetchCertificateData(projectId, [assetIds], [yieldIds], yieldPeriod, projectOrgId);
        if (cropData) {
          const { cropLabel, cropYieldEmissions, emissionReductionOverview } = cropData;
          const { totalCropYield } = cropYieldEmissions;
          const { delta: credits } = emissionReductionOverview;
          setDescriptionData({
            projectName,
            projectIdReadable,
            creditBundles,
            cropLabel,
            totalCropYield,
            credits
          })
        }
      } finally {
        setSpinning(false);
      }
    })();
  }, [yieldsRequiringSourcing, projectOrgId, yieldPeriod, projectId])

  return (
    <Spin spinning={spinning}>
      <Typography.Title level={4}>Source volume declaration</Typography.Title>
      <Typography.Paragraph>Before retiring these credits, confirm that your organisation sourced the crop volumes linked to this bundle.</Typography.Paragraph>
      { descriptionData && (
        <>
          <Descriptions bordered column={1} size="small" style={{maxWidth: "700px"}} contentStyle={{textAlign: "right"}}>
            <Descriptions.Item label="Project">{descriptionData.projectName}</Descriptions.Item>
            <Descriptions.Item label="Project ID">{descriptionData.projectIdReadable}</Descriptions.Item>
            <Descriptions.Item label="Credit Bundle">{descriptionData.creditBundles}</Descriptions.Item>
            <Descriptions.Item label="Crop">{descriptionData.cropLabel}</Descriptions.Item>
            <Descriptions.Item label="Crop Volume">{descriptionData.totalCropYield}</Descriptions.Item>
            <Descriptions.Item label="Credits">{descriptionData.credits?.toFixed(2)}</Descriptions.Item>
          </Descriptions>
          <hr style={{margin: "20px 0px"}} />
          <div className="p-3 bg-gray-50 border border-gray-300 rounded">
            <Checkbox onChange={(e) => onDeclarationChange(e.target.checked)}>
              I confirm that <span className="font-semibold">{userOrgName}</span> sourced <span className="font-semibold">{descriptionData.totalCropYield} metric tonnes</span> of <span className="font-semibold">{descriptionData.cropLabel}</span> from this project in the {yieldPeriod} season.
            </Checkbox>
          </div>
        </>
      )}
    </Spin>
  )
}